import type { FilterFn } from "@tanstack/react-table";
import type { Entry } from "../normalize";
import type { EnumFilterValue } from "./types";

export const enumFilterFn: FilterFn<Entry> = (row, columnId, raw) => {
	const f = raw as EnumFilterValue | undefined;
	if (!f) return true;
	if (f.values.length === 0) return false;
	const cell = row.getValue(columnId) as string | null;
	return cell != null && f.values.includes(cell);
};
